import { render, staticRenderFns } from "./JournalsPublish.vue?vue&type=template&id=f4433710&scoped=true&"
import script from "./JournalsPublish.vue?vue&type=script&lang=js&"
export * from "./JournalsPublish.vue?vue&type=script&lang=js&"
import style0 from "./JournalsPublish.vue?vue&type=style&index=0&id=f4433710&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4433710",
  null
  
)

export default component.exports